import React from 'react';
import { useSelector } from '@xstate/react';

import { filtersOptionsSelectors } from '../../machines/filtersOptions';
import { useServices } from '../../hooks';

import { PRODUCT_SEARCH_THRESHOLD } from './constants';
import { Product } from '../../models/billingHistory/billingHistory';

export type ProductsContainerProps = {
  /**
   * Children renderer
   */
  children: (props: {
    products: Product[];
    showSearch: boolean;
  }) => React.ReactNode;
};

const ProductsContainer = ({ children }: ProductsContainerProps) => {
  const { filtersOptionsService } = useServices();
  const { products } = useSelector(
    filtersOptionsService,
    filtersOptionsSelectors.getProducts
  );

  if (!products || products.length <= 1) {
    return null;
  }

  const showSearch = products.length > PRODUCT_SEARCH_THRESHOLD;

  return <>{children({ products, showSearch })}</>;
};

export default ProductsContainer;
